import { Spacing, Colors } from "@constants"
import { StyleSheet } from "react-native"

export const badgeTemplateStyles = (
  isMobile: boolean,
  successfullyAddedHolding: boolean
) =>
  StyleSheet.create({
    container: {
      flex: 1,
      width: "100%",
      alignItems: "center",
    },
    title: {
      paddingBottom: Spacing.XXL,
      maxWidth: isMobile ? "100%" : "410px",
    },
    stepsContainer: {
      width: "100%",
      maxWidth: isMobile ? "100%" : 600,
      flexDirection: "column",
      justifyContent: "flex-start",
      alignItems: "center",
      backgroundColor: Colors.white,
      marginVertical: Spacing.XXL,
      borderColor: Colors.lightGray,
      borderRadius: isMobile ? 0 : 12,
      borderWidth: 1,
      paddingVertical: successfullyAddedHolding ? 0 : Spacing.XL,
      shadowColor: "#000",
      shadowOpacity: 0.3,
      shadowRadius: 10,
      paddingHorizontal: isMobile && !successfullyAddedHolding ? Spacing.XL : 0,
    },
    backGroundImage: {
      position: "absolute",
      top: 0,
      left: 0,
      width: "100%",
      height: "100%",
      zIndex: -1,
    },
    backButtonContainer: {
      position: isMobile ? 'relative' : "absolute",
      paddingBottom: Spacing.XXL,
      right: isMobile ? 0 : "5%",
      top: 0,
      bottom: 0,
      marginLeft: isMobile ? 10 : 0
    },
    titleContainer: {
      flexDirection: 'row',
      justifyContent: 'center',
      width: "100%"
    }
  }
)
